const GO_TEST_NAMES = {
  clipPreviewUsesWebGL: "clipPreviewUsesWebGL",
  widget_filter: "widget_filter",
  calendar_reposition: "calendar_reposition",
  searchclips: "searchclips",
  syb_home_promo: "syb_home_promo",
  smartcast: "smartcast",
  syb_promo: "syb_promo",
};

export { GO_TEST_NAMES };
